import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
// import { AppraisalContainerComponent } from './components/appraisal-container/appraisal-container.component';
import { AppraisalTableComponent } from './components/appraisal-table/appraisal-table.component';
import { CloserContainerComponent } from './components/closer-container/closer-container.component';
import { CommentsContainerComponent } from './components/comments-container/comments-container.component';
import { SiteInformationComponent } from './components/site-information/site-information.component';
import { ImprovementInformationComponent } from './components/improvement-information/improvement-information.component';
import { ScopeOfWorkComponent } from './components/scope-of-work/scope-of-work.component';
import { LoginComponent } from './components/login/login/login.component';
import { TestComponent } from './components/test/test.component';
import { DashboardContainerComponent } from './components/dashboard-container/dashboard-container.component';
import { CppibComponent } from './components/cppib/cppib.component';
import { AppraisalItemComponent } from './components/appraisal-item/appraisal-item.component';
import { ArgusComponent } from './components/argus/argus.component';
import { ArgusPowerBiComponent } from './components/argus-power-bi/argus-power-bi.component';
import { ChangeHistoryComponent } from './components/change-history/change-history.component';
import { RatingsComponent } from './components/ratings/ratings.component';
import { ComparablesComponent } from './components/comparables/comparables.component';
import { ComparableSalesComponent } from './components/comparable-sales/comparable-sales.component';
import { ComparableRentsComponent } from './components/comparable-rents/comparable-rents.component';
import { ComparableExpenseComponent } from './components/comparable-expense/comparable-expense.component';
import { ComparableLandComponent } from './components/comparable-land/comparable-land.component';
import { AllowanceComponent } from './components/allowance/allowance.component';
import { AllowanceStatusComponent } from './components/allowance-status/allowance-status.component';
import { AppealStatusComponent } from './components/appeal-status/appeal-status.component';
import { AppealSavingsComponent } from './components/appeal-savings/appeal-savings.component';
import { PropertySearchComponent } from './components/property-search/property-search.component';
import { LiabilityComponent } from './components/liability/liability.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HomeComponent } from './components/home/home.component';
import { PromptsComponent } from './components/prompts/prompts.component';

export const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent, canActivate: [MsalGuard]},
    { path: 'home/dashboard', component: DashboardContainerComponent , canActivate: [MsalGuard]},
    { path: 'home/argus', component: ArgusPowerBiComponent , canActivate: [MsalGuard]},
    { path: 'grid', component: AppraisalTableComponent ,canActivate: [MsalGuard]},
    { path: 'vault', component: CppibComponent ,canActivate: [MsalGuard]},
    { path: 'prompt', component: PromptsComponent ,canActivate: [MsalGuard]},
    // { path: 'ratings', component: RatingsComponent },
    { path: 'ratings/liability', component: LiabilityComponent ,canActivate: [MsalGuard]},
    { path: 'ratings/allowance', component: AllowanceComponent ,canActivate: [MsalGuard]},
    { path: 'ratings/allowanceStatus', component: AllowanceStatusComponent ,canActivate: [MsalGuard]},
    { path: 'ratings/appealSavings', component: AppealSavingsComponent ,canActivate: [MsalGuard]},
    { path: 'ratings/appealStatus', component: AppealStatusComponent ,canActivate: [MsalGuard]},
    { path: 'ratings/propertySearch', component: PropertySearchComponent ,canActivate: [MsalGuard]},
    { path: 'closer', component: CloserContainerComponent ,canActivate: [MsalGuard]},
    { path: 'comments', component: CommentsContainerComponent ,canActivate: [MsalGuard]},
    { path: 'site', component: SiteInformationComponent ,canActivate: [MsalGuard]},
    { path: 'improvement', component: ImprovementInformationComponent ,canActivate: [MsalGuard]},
    { path: 'scopeOfWork', component: ScopeOfWorkComponent ,canActivate: [MsalGuard]},
    { path: 'test', component: TestComponent ,canActivate: [MsalGuard]},
    { path: 'login', component: LoginComponent ,canActivate: [MsalGuard]},
    { path: 'activity-details/:id', component: AppraisalItemComponent ,canActivate: [MsalGuard]},
    { path: 'activity-details/argus/:id', component: ArgusComponent ,canActivate: [MsalGuard]},
    { path: 'activity-details/changeHistory/:id', component: ChangeHistoryComponent ,canActivate: [MsalGuard]},
    {
        path: 'activity-details/comparables/:id', component: ComparablesComponent,
        children: [
            // { path: '', pathMatch: 'full', redirectTo: 'sales' },
            {
                path: 'sales',
                loadComponent: () => ComparableSalesComponent,
            },
            {
                path: 'rent',
                loadComponent: () => ComparableRentsComponent,
            },
            {
                path: 'expense',
                loadComponent: () => ComparableExpenseComponent,
            },
            {
                path: 'land',
                loadComponent: () => ComparableLandComponent,
            },
        ],
        canActivate: [MsalGuard]
    },
    { path: 'not-found', component: DashboardContainerComponent ,canActivate: [MsalGuard]},
    { path: '404', component: NotFoundComponent ,canActivate: [MsalGuard]},
    { path: '**', component: NotFoundComponent ,canActivate: [MsalGuard]} // keep this LAST
];